/**
 * AppToolbar.js
 *
 * Copiado e adaptado de hay-hotspot/assets/reactweb/src/components/ui/AppToolbar.js
 * (Fase 1.6) — removido o botão/dialog de "release notes" (`auth.urlReleaseNotes`, serviço
 * externo do hay-hotspot sem equivalente aqui) e trocado o título fixo pela chave i18n.
 */
import React, { Component, createRef } from 'react';

import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { Menu } from 'primereact/menu';
import { confirmDialog } from 'primereact/confirmdialog';

import { UtilService } from 'hay-core-react';
import IconeHay from '../../images/logo-loading.png';

class AppToolbar extends Component {

  constructor(props) {
    super(props);
    this.menuRef = createRef();
  }

  sair() {
    UtilService.efetuarLogout();
  }

  redefinirInterface(t) {
    confirmDialog({
      header: t('main.toolbar.redefinirInterface.confirmacao.header'),
      message: t('main.toolbar.redefinirInterface.confirmacao.mensagem'),
      icon: 'pi pi-refresh',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-warning',
      draggable: false,
      className: 'w-3',
      accept: () => {
        const auth = UtilService.getLocalStorage('auth');
        localStorage.clear();
        UtilService.saveLocalStorage('auth', auth);
        UtilService.showToast({
          severity: 'success',
          summary: t('main.toolbar.redefinirInterface.sucesso'),
          detail: t('main.toolbar.redefinirInterface.sucesso.detalhe'),
        });
      },
    });
  }

  render() {
    const { auth, onToggleSidebar, onToggleConfigurator } = this.props;
    const t = (chave) => UtilService.traduzir(chave);

    const userMenuItems = [
      {
        template: () => (
          <div className="px-3 py-2" style={{ overflow: 'hidden' }}>
            <div className="flex align-items-center gap-2">
              <Avatar icon="pi pi-user" shape="circle" style={{ flexShrink: 0 }} />
              <span className="font-bold" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{auth.nome}</span>
            </div>
            {auth.grupoNome && (
              <div className="flex align-items-center gap-2 mt-1 text-color-secondary text-sm" style={{ paddingLeft: '2.25rem' }}>
                <i className="pi pi-tags" style={{ flexShrink: 0 }} />
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{auth.grupoNome}</span>
              </div>
            )}
            {auth.publicacaoNome && (
              <div className="flex align-items-center gap-2 mt-1 text-color-secondary text-sm" style={{ paddingLeft: '2.25rem' }}>
                <i className="pi pi-globe" style={{ flexShrink: 0 }} />
                <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{auth.publicacaoNome}</span>
              </div>
            )}
          </div>
        ),
      },
      { separator: true },
      { label: t('main.toolbar.redefinirInterface'), icon: 'pi pi-refresh', command: () => this.redefinirInterface(t) },
      { label: t('main.toolbar.sair'), icon: 'pi pi-sign-out', command: () => this.sair() },
    ];

    const start = (
      <span className="inline-flex align-items-center gap-2">
        <Button id="menu-principal"
          icon="pi pi-bars"
          text
          severity="secondary"
          size="small"
          onClick={onToggleSidebar}
          tooltip="Menu"
          tooltipOptions={{ position: 'bottom' }}
        />
        <img src={IconeHay} alt="logo" width="28" height="28" />
        <span className="font-semibold text-xl text-primary">HaY LinkInsight</span>
      </span>
    );

    const end = (
      <div className="flex align-items-center gap-1">
        <Button
          icon="pi pi-palette"
          label="Tema"
          text
          severity="secondary"
          size="small"
          onClick={onToggleConfigurator}
          tooltip="Personalizar tema"
          tooltipOptions={{ position: 'bottom' }}
        />
        <Button
          text
          severity="secondary"
          size="small"
          className="gap-2"
          onClick={e => this.menuRef.current.toggle(e)}
        >
          <Avatar icon="pi pi-user" shape="circle" size="small" />
          <span className="font-medium">{auth.nome}</span>
          <i className="pi pi-chevron-down text-xs" />
        </Button>
        <Menu
          ref={this.menuRef}
          model={userMenuItems}
          popup
          pt={{
            root: { style: { width: 'auto', maxWidth: '200px' } },
            menuitem: { style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
            label: { style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
          }}
        />
      </div>
    );

    return (
      <Toolbar
        start={start}
        end={end}
        className="border-noround border-bottom-1 surface-border px-4 py-2"
        style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}
      />
    );
  }
}

export default AppToolbar;
